import axios from 'axios';
import { SIGN_TRANSCRIPTION_URL, SIGN_URL } from './settings';

export const getUploadURLSigned = (fileName) => {
    let url = SIGN_URL + fileName;

    return axios.get(
        url,
        {
            params: {
                source_content_type: 'application/json'
            }
        }
    ).then(
        (res) => {
           // console.log("URL Signed:");
            //console.log(res);
            return res;
        }
    );
}

export const getDownloadURLSigned = (fileName) => {
    let url = SIGN_TRANSCRIPTION_URL + fileName;

    return axios.get(
        url,
        {
            params: {
                source_content_type: 'application/json'
            }
        }
    ).then(
        (res) => {
           // console.log("URL Singed");
           // console.log(res);
            return res;
        }
    );
}

export const uploadFile = (signedURL, file) => {
    // var formData = new FormData();

    let headers = {
        'Content-Type': 'multipart/form-data'
    };

    // formData.append('file', file);
    // console.log("Form Data: ", formData);

    return axios(
        {
            method: 'put',
            url: signedURL,
            data: file,
            headers: headers
        }
    ).then(
        (res) => {
          //  console.log("Upload file res:");
          //  console.log(res);
            return res;
        }
    );
}

export const fetchTXT = (signedURL) => {
    return axios.get(
        signedURL
    ).then(
        (res) => {
           // console.log("Fetch TXT:");
           // console.log(res);
            return res;
        }
    );
}

export async function initSignURL(fileName) {
    const urlSigned = await getUploadURLSigned(fileName).then(
        res => { return res; }
    );

    return urlSigned;
}

export async function initSignURLDownload(fileName) {
    const urlSigned = await getDownloadURLSigned(fileName).then(
        res => { return res; }
    );

    return urlSigned;
}

export async function initUploadFile(signedURL, file) {
    const upload = await uploadFile(signedURL, file).then(
        res => { return res; }
    );

    return upload;
}

export async function initFetchTXT(signedURL) {
    const txt = await fetchTXT(signedURL).then(
        res => { return res; }
    );

    return txt;
}

export const getSignedUrl = (signedURL) => {

    return axios(
        {
            method: 'get',
            url: SIGN_TRANSCRIPTION_URL + encodeURIComponent(signedURL),
        }
    )
}